import { AvailableStatus } from 'components/availableStatus/AvailableStatus'
import { Button } from 'components/button/Button'
import { useFreshdesk } from 'components/directive/utils/useFreshdesk'
import { useHideFreshDeskButton } from 'components/directive/utils/useHideFreshDeskButton'
import { Spacer } from 'components/spacer/Spacer'
import { HStack, Stack } from 'components/Stack'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { colors } from 'utils/colors'
import { useWindowSize } from 'utils/hooks'
import { SCardWrapper } from './SupportSideBar.styled'

export function SupportSideBar() {
  const { t } = useTranslation('directive')
  const { isDesktop } = useWindowSize()

  useHideFreshDeskButton()
  const freshdesk = useFreshdesk()

  const contactUsButton = (
    <div css={{ alignSelf: 'flex-start' }}>
      <Button
        type="button"
        variant="text"
        onClick={() => {
          freshdesk.open()
        }}
      >
        {t('directive.support_sidebar.contact_button')}
      </Button>
    </div>
  )
  return (
    <>
      <div />
      <div>
        <SCardWrapper>
          <Stack space={['0.5rem', '1rem']}>
            <HStack css={{ justifyContent: 'space-between' }}>
              <Text variant="bodyBold" color={colors.black}>
                {t('directive.support_sidebar.title')}
              </Text>
              {!isDesktop && contactUsButton}
            </HStack>
            <Text variant="body">{t('directive.support_sidebar.text')}</Text>
            <HStack space="1rem">
              <div>
                <img
                  src="/images/trust_support_lady.png"
                  height={56}
                  width={56}
                  css={{
                    borderRadius: '50%',
                  }}
                />
              </div>
              <AvailableStatus text={t('directive.support_sidebar.available')} />
            </HStack>
            {isDesktop && contactUsButton}
          </Stack>
        </SCardWrapper>
        <Spacer size={[0, '2rem']} />
      </div>
    </>
  )
}
